import { useState, useEffect } from 'react'

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera

            // Check for common mobile device identifiers
            const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
            const isMobileUA = mobileRegex.test(userAgent)

            // Also check screen width as a fallback/OR condition
            const isSmallScreen = window.innerWidth < 768

            setIsMobile(isMobileUA || isSmallScreen)
        }

        checkMobile()

        // Add resize listener to handle window resizing (e.g. devtools toggle)
        window.addEventListener('resize', checkMobile)

        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    return isMobile
}
